import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import '../element-variables.scss'
// import 'element-ui/lib/theme-default/index.css'
// import './assets/theme/theme-green/index.css'
import 'font-awesome/css/font-awesome.min.css'
import VueRouter from 'vue-router'
import store from './store'
import Vuex from 'vuex'
import axios from 'axios'
import filter from './filter'
import router from './router'
import './permission'
// import routes from './routes'
import moment from 'moment'


Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
import { Message, Loading } from 'element-ui'

Vue.prototype.usrCloudUser = 'hlfchina'

Vue.prototype.$axios = axios
// axios.defaults.baseURL = process.env.API_ROOT
axios.defaults.withCredentials = true

let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}
// 拦截器
axios.interceptors.request.use(
    config => {
        let user = JSON.parse(sessionStorage.getItem('user') || '{}')
        if (user.token) {
            if (config.url.indexOf('/service') == 0) {
                config.headers['token'] = user.token
                config.headers['loginuser'] = user.account
            }
            if (typeof config.data === 'string') {
                config.data = config.data + "&token=" + user.token
            } else {
                config.data = config.data || {}
                config.data = Object.assign(config.data, { token: user.token })
            }
        }
        showFullScreenLoading()
        return config
    },
    error => {
        console.log(error) // for debug

    }
)
axios.interceptors.response.use(
    res => {
        console.log('res=====', res)
        if (res.status === 200 && res.data.status != 0) {
            if (res.data.status === 4010) {
                Vue.prototype.$message({
                    message: '会话失效，请重新登录',
                    type: 'warning'
                })
                router.replace('/login')
            } else if(res.data.status === 5126){
                //return Promise.reject(res)
            } else {
                res.config.responseType !== 'blob' && res.data.info && Vue.prototype.$message({
                    message: res.data.info,
                    type: 'warning'
                })
            }
        }
        tryHideFullScreenLoading()
        return res
    },
    error => {
        tryHideFullScreenLoading()
        Vue.prototype.$message({
            type: 'error',
            message: '系统异常，请稍后再试'
        });
        return Promise.reject(error)
    }
)

// 过滤器
Object.keys(filter).forEach(k => Vue.filter(k, filter[k]));
// 时间格式
Vue.filter('DateFormat', function (dataStr, pattern) {
    return moment(dataStr).format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('DateFormatLong', function (dataStr, pattern) {
    if (dataStr === 0) {
        return '--'
    }
    return moment.unix(dataStr).format(pattern)
})


// const router = new VueRouter({
//     routes
// })

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js